export const defaultHomeContent = {
  landing: {
    title: "",
    subtitle: "",
  },
  welcome1: {
    from: "",
    summary: "",
    messageBody: "",
  },
  welcome2: {
    from: "",
    summary: "",
    messageBody: "",
  },
  videoSection: {
    title: "",
    url: "",
  },
  carnivalDiary: {
    title: "",
    month: "",
    year: "",
    dateTime: "",
    location: "",
  },
};

export const defaultAboutContent = {
  title: "",
  subtitle: "",
  summary: "",
  body: "",
};
export const defaultCarnivalContent = {
  title: "",
  subtitle: "",
  theme: "",
  mainStageLineup: "",
  parkRoute: "",
  perfAreaTitleMain: "",
  perfAreaTitleExtra: "",
  closing: "",
};
export const defaultTicketContent = {
  title: "",
  subtitle: "",
};
export const defaultContactContent = {
  pageContent: {
    title: "",
    subtitle: "",
    contactFormTitle: "",
    mapTitle: "",
    mapSubtitle: "",
    closing: "",
  },
  contactInfo: {
    email: "",
    phone: "",
    strAddr: "",
    city: "",
    postalCode: "",
  },
  officeHours: {
    timeStart: "",
    timeEnd: "",
    dayStart: "",
    dayEnd: "",
  },
  directions: [],
};

export const footerContent = {
  sections: [],
};

export const defaultEvent = {
  name: "",
  date: "",
  gatesOpen: "",
  venue: "",
  city: "",
  postalCode: "",
  contractsDeadline: "",
};
